import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Power Infusion",
    "spell_holy_powerinfusion",
    [
      "Infuses the target with power, increasing their spell damage and healing by 20% for 15 sec.",
    ],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    "20% of base mana",
    "30 yd range",
    "Instant",
    "3 min cooldown"
  ),
  null,
  null,
];

export default tier7;
